var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
// libs
import React from 'react';
import { memo } from 'react';
// HOC
import withIconDefaults from './withIconDefaults';
function Download(_a) {
    var { fillColor } = _a, props = __rest(_a, ["fillColor"]);
    return (React.createElement("svg", Object.assign({ viewBox: "0 0 20 20", fill: "none" }, props),
        React.createElement("path", { d: "M1.58398 13.6666C1.25065 13.6666 0.958984 13.5416 0.708984 13.2916C0.458984 13.0416 0.333984 12.75 0.333984 12.4166V9.43748H1.58398V12.4166H12.4173V9.43748H13.6673V12.4166C13.6673 12.75 13.5423 13.0416 13.2923 13.2916C13.0423 13.5416 12.7507 13.6666 12.4173 13.6666H1.58398ZM7.00065 10.4791L2.97982 6.45831L3.87565 5.56248L6.37565 8.06248V0.333313H7.62565V8.06248L10.1257 5.56248L11.0215 6.45831L7.00065 10.4791Z", fill: fillColor })));
}
export default memo(withIconDefaults(Download));
